import React from 'react';

const VideoBanner = () => {
    const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);

    React.useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 768);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <section style={{
            position: 'relative',
            width: '100%',
            backgroundColor: '#000',
            paddingTop: isMobile ? '0' : '48px',
            paddingBottom: isMobile ? '0' : '48px',
            overflow: 'hidden'
        }}>
            {/* Container with 70% width on desktop, full width on mobile */}
            <div style={{
                width: '100%',
                margin: '0 auto',
                paddingLeft: isMobile ? '0' : '16px',
                paddingRight: isMobile ? '0' : '16px'
            }}>
                <div style={{
                    width: '100%',
                    maxWidth: isMobile ? '100%' : '70%',
                    margin: '0 auto'
                }}>
                    <video
                        style={{
                            width: '100%',
                            height: 'auto',
                            display: 'block',
                            backgroundColor: '#000',
                            borderRadius: isMobile ? '0' : '12px',
                            boxShadow: isMobile ? 'none' : '0 25px 50px -12px rgba(0, 0, 0, 0.5)'
                        }}
                        controls
                        playsInline
                        loop
                        muted={true}
                        preload="metadata"
                    >
                        <source src="/resources/SQINBOX-AD-Intro-dec25-comp.mp4" type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>
            </div>
        </section>
    );
};

export default VideoBanner;